import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import useStyles from './styles';
import useStylesHeader from './stylesHeader';

function Paper({
  Icon,
  title,
  subtitle,
  children,
  actions,
  iconColor,
  loading,
  classes,
  showHeader = true
}) {
  const classesRoot = useStyles();
  const classesHeader = useStylesHeader();

  return (
    <Card
      classes={{
        root: clsx(classesRoot.root, classes.root),
      }}
    >
      { showHeader && <CardHeader
        classes={{
          root: clsx('no-printable', classesHeader.root, classesHeader[iconColor], classes.iconRootHeader),
          avatar: classesRoot.avatar
        }}
        avatar={
          loading ?
            <CircularProgress className={clsx(classesRoot.loading, classes.loading)} /> :
            <Icon className={clsx(classesRoot.icon, classes.iconHeader)} />
        }
      /> }
      <CardContent style={ !title ? { marginTop: 50 } : null }>
        { title && <div className={!subtitle ? clsx(classesRoot.header, classes.header) : null}>
          <Typography variant="h5" className={subtitle ? clsx(classesRoot.titleWithSubtitle) : clsx(classesRoot.title, classes.title)}>{title}</Typography>
          { subtitle && <Typography variant="subtitle1" className={clsx(classesRoot.subtitle)}>{subtitle}</Typography> }
          {actions}
        </div>}
        {!loading && children}
      </CardContent>
    </Card>
  );
}

Paper.defaultProps = {
  iconColor: 'blue',
  classes: {},
  loading: false,
};

export const paperPropTypes = {
  Icon: PropTypes.any,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  iconColor: PropTypes.oneOf([
    'primary',
    'second',
    'success',
    'warning',
    'error',
    'blue',
    'orange',
    'green',
    'purple',
    'red',
  ]),
  classes: PropTypes.shape({
    root: PropTypes.string,
    iconRootHeader: PropTypes.string,
    iconHeader: PropTypes.string,
    header: PropTypes.string,
    title: PropTypes.string,
    loading: PropTypes.string,
  }),
  title: PropTypes.node,
  loading: PropTypes.bool,
};

Paper.propTypes = paperPropTypes;

export default Paper;
